import * as React from "react";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { showError } from "nsitools-react";
import { Button } from "@blueprintjs/core";
import { FileResponse } from "../../api";
import { saveAs } from "file-saver";

export interface IExportButtonProps {
  exportFunction?: (sObj: any) => Promise<FileResponse>;
  sObj?: any;
}

export const ExportButton: React.FunctionComponent<IExportButtonProps> = ({ sObj, exportFunction }) => {
  const { t } = useTl();
  const [loading, setloading] = React.useState(false);
  const ExportAndDownlad = React.useCallback(async () => {
    setloading(true);
    try {
      const file = await exportFunction(sObj);
      saveAs(file.data, file.fileName);
    } catch {
      showError(t(ETLCodes.Error));
    }
    setloading(false);
  }, [exportFunction, sObj, t]);
  return (
    <Button
      loading={loading}
      text={t(ETLCodes.ExcelExport)}
      icon={<i className="far fa-file-excel" />}
      onClick={ExportAndDownlad}
      minimal={true}
      intent={"primary"}
    />
  );
};
